import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Grid } from "@mui/material";
import { MprcContainer, MprcTypography } from "components";
import { MprcButton } from "components/MprcButton";
import { TrainingComponentType } from "generated/CoreApi_v1";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useEnrollmentViewContext } from "views/lms/student/EnrollmentView";
import { useCourseEnrollmentViewContext } from "views/lms/student/EnrollmentView/Course/CourseEnrollmentView";
import { launchSco } from "views/lms/student/EnrollmentView/Shared/EnrollmentActions";



export const ScoContent: React.FC = () => {

    const { t } = useTranslation("lms");
    const { enrollment, onReload } = useEnrollmentViewContext();
    const { currentComponent } = useCourseEnrollmentViewContext();


    const handleLaunchSco = useCallback(() => {
        launchSco(enrollment.enrollmentId, currentComponent!.scoComponent!, onReload, enrollment.readOnly);
    }, [enrollment, currentComponent, onReload]);

    const getScoAction = () => {

        var buttonText = "";
        if (currentComponent?.scoComponent != null && currentComponent.componentType === TrainingComponentType.Sco) {

            const lessonStatus = currentComponent.scoComponent.lessonStatus;
            if (lessonStatus == null || lessonStatus === "not attempted") {

                buttonText = t("Student.EnrollmentView.ScoStartButtonText");
            }
            else if (lessonStatus === "incomplete") {
                buttonText = t("Student.EnrollmentView.ScoContinueButtonText");
            }
            else {
                if (lessonStatus === "completed" || lessonStatus === "passed" || lessonStatus === "failed") {
                    buttonText = enrollment.canFinish || enrollment.finalizationDate != null ? t("Student.EnrollmentView.ScoReviewButtonText") : `${t("Student.EnrollmentView.ScoReviewButtonText")} / ${t("Student.EnrollmentView.ScoRemakeButtonText")}`;
                }
            }

            return <MprcButton
                sx={{ width: 200 }}
                color="primary"
                variant="contained"
                title={buttonText}
                onClick={handleLaunchSco}
            >
                <Grid container spacing={2} width="100%">
                    <Grid size="grow" alignSelf="center">
                        {buttonText}
                    </Grid>
                    <Grid>
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} fixedWidth />
                    </Grid>
                </Grid>
            </MprcButton>;
        }
    };

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcContainer>
                <Card>
                    <CardContent>
                        <MprcContainer>
                            <MprcTypography variant="h5">{currentComponent?.title}</MprcTypography>
                        </MprcContainer>
                        {getScoAction()}
                    </CardContent>
                </Card>
            </MprcContainer>
        </>
    );
};
